import React from 'react';
import { useField } from 'formik';

import { DatePickerWithLabel } from '../molecules';

export function DatePickerField(props) {
  const [field, meta] = useField(props);

  const error = meta.touched && meta.error ? meta.error : undefined;

  return <DatePickerWithLabel error={error} {...field} {...props} />;
}
